import styles from "./Card.module.css";
import { ReactComponent as CarIcon } from "../../../assets/svg/serviceCar.svg";
import { ReactComponent as IdIcon } from "../../../assets/svg/serviceId.svg";
import { useTranslation } from "react-i18next";
import { ReactComponent as Verify } from "../../../assets/svg/verify.svg";
import { ReactComponent as UnVerify } from "../../../assets/svg/unverify.svg";
import { ReactComponent as UserIcon } from "../../../assets/svg/user.svg";

import { ReactComponent as MobileIcon } from "../../../assets/svg/mobile-icon.svg";
import { Button } from "antd";
import { useLangNavigate } from "../../../hooks/useLangNavigate";

export default function ServiceCard({
  customer,
  created_at,
  id,
  car,
  is_verified,
}) {
  const { t, i18n } = useTranslation();
  const navigate = useLangNavigate();
  return (
    <div className={styles.CardContainer}>
      <div>
        <div>
          <span>{created_at?.replaceAll("-", "/")}</span>
        </div>
        <div>
          {is_verified ? (
            <div className={`${styles.verifyBadge} ${styles.verified}`}>
              <Verify className={styles.icon} />
              {t("common.verified")}
            </div>
          ) : (
            <div className={`${styles.verifyBadge} ${styles.unverified}`}>
              <UnVerify className={styles.icon} />
              {t("common.unverified")}
            </div>
          )}
        </div>
      </div>
      <div
        className={`${styles.box} ${i18n.dir() === "rtl" ? styles.rtl : ""}`}
      >
        <div>
          <IdIcon className={styles.icon} /> {t("common.id_number")}:
        </div>
        <div>{id}</div>
        <div>
          <UserIcon className={styles.icon} />
          {t("appointment.customer_name")}:
        </div>
        <div>{customer.fullname}</div>

        <div>
          <MobileIcon className={styles.icon} />
          {t("appointment.customer_phone")}:
        </div>
        <div>{customer.mobile}</div>
        <div>
          <CarIcon className={styles.icon} /> {t("services.car_model")}:
        </div>
        <div>{car}</div>
      </div>
      <div className={styles.cardAction}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            navigate(`/services/${id}`);
          }}
        >
          {t("cart.more_details")}
        </Button>
      </div>
    </div>
  );
}
